import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Predictable turnaround",
      "Ideal for upcoming trips",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service",
      "Good for planned travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Workload & wait times shift with shutdowns and budget fights",
      "In-person clerk appointment required",
      "No document review — errors cause rejection",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Can't upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Appointment required — no walk-ins allowed",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

const emergencyText =
  "Iowa has ZERO passport agencies — the state's 3.2M residents have no in-state emergency option. Closest: Chicago ~340 mi (5.5+ hrs) or Minneapolis ~220 mi (3.5 hrs). Iowa State University sends thousands of students abroad annually through its highly-ranked study-abroad programs — a Cyclone student discovering an expired passport 48 hours before departure to a semester in Valencia or Shanghai faces a 7–11 hour round trip on I-35, which becomes impassable during winter blizzards (Nov–March). When I-35 closes due to whiteout conditions and multi-car pileups, Ames is geographically severed from every passport agency in the country — Chicago's single agency might as well be on another continent.";

const disclaimerText =
  "*Processing speed depends on eligibility and documentation. Not all applicants qualify for Regional Agency Processing.";

export default function AmesProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Ames"
      introText="Ames travelers — Iowa State University students heading to study abroad, agricultural researchers at international conferences, and Story County families on mission trips — have several options for getting a passport fast. Here's how they compare, and why most Ames residents choose a registered U.S. Department of State courier for predictable, professional processing."
      options={options}
      emergencyDescription={emergencyText}
      disclaimerText={disclaimerText}
    />
  );
}